<div class="popup forgottenPasswordPopup">
    <button class="close-button" (click)="close()"></button>
    <div class="forgottenPasswordPopup-content">
        <div class="forgottenPasswordPopup-content-illu"></div>
        <h2 class="forgottenPasswordPopup-content-title _primary"[i18nKey]="'login.reset.password.title'"></h2>
        <p class="forgottenPasswordPopup-content-description"[i18nKey]="'login.reset.password.description'"></p>
        <label class="_fullWidth">
            <span [i18nKey]="'login.reset.password.id.label'"></span>
            <input type="text" [i18nKey]="[{target: 'attribute:placeholder', key: 'login.reset.password.id.placeholder'}]" [(ngModel)]="username"/>
        </label>
        <div *ngIf="errorIsShown" class="errorBlock">
            <div class="errorBlock-message" [innerHTML]="'login.reset.password.error.login'|translate" [i18nKey]="[{target: 'innerHTML', key: 'login.reset.password.error.login'}]"[i18nKey]="'login.reset.password.error.login'"></div>

            <div class="errorBlock-actions">
                <button class="button _cancel" (click)="close()"[i18nKey]="'common.action.cancel'"></button>
                <button class="button" (click)="regeneratePassword(username)"[i18nKey]="'common.action.resend'"></button>
            </div>
        </div>
        <button *ngIf="!errorIsShown" class="button sendNewPassword"
                (click)="regeneratePassword(username)"[i18nKey]="'login.reset.password.button'"></button>
    </div>
</div>
<div class="overlay"></div>
